import { render } from "./AnagraficaClienti.vue?vue&type=template&id=ebb5e50c&scoped=true"
import script from "./AnagraficaClienti.vue?vue&type=script&lang=js"
export * from "./AnagraficaClienti.vue?vue&type=script&lang=js"

import "./AnagraficaClienti.vue?vue&type=style&index=0&id=ebb5e50c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebb5e50c"]])

export default __exports__